import { Button } from '../../../ui/Button';
import { ShareIcon } from '../../../ui/icons';

export type SocialActionButtonProps = {
  onClick: () => void;
  'aria-label': string;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
};

export const ShareButton = ({
  onClick,
  'aria-label': ariaLabel,
  disabled = false,
  size = 'md',
}: SocialActionButtonProps) => (
  <Button
    shape="circle"
    tone="neutral"
    emphasis="outlined"
    size={size}
    onClick={onClick}
    aria-label={ariaLabel}
    title={ariaLabel}
    disabled={disabled}
  >
    <ShareIcon />
  </Button>
);
